<script setup>
import {computed} from 'vue';
import {useI18n} from 'vue-i18n';
import EnSpinner from 'Components/feedback/EnSpinner/EnSpinner.vue';

/**
 * A simple loading spinner overlaying the content at the center of the screen.
 */
const props = defineProps({
  /**
   * Text displayed next to the loading spinner.
   */
  text: {
    type: String,
  }
});
const modelValue = defineModel('modelValue');
const {t} = useI18n();

const textComputed = computed(() => {
  return props.text ?? t('common.loading');
});

</script>

<template>
  <div v-if="modelValue" class="en-overlay">
    <div class="en-overlay-content">
      <div class="flex flex-wrap flex-auto justify-center p-3 en-overlay-spinner-content">
        <en-spinner color="white"/>
        {{ textComputed }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "Styles/helper/variables" as *;

.en-overlay {
  position: fixed;
  inset: 0;
  z-index: 2400;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(0 0 0 / 0.32);
}

.en-overlay-content {
  width: 200px;
  background-color: $en-red;
  border-radius: 0.375rem;
}

.en-overlay-spinner-content {
  font-size: 1rem;
  color: $en-0 !important;
}
</style>